export default class PageConfig {
  public static isSSR = typeof window === "undefined";
  public static tenant = process.env.GATSBY_TENANT || "vistaprint";
  public static requestor = PageConfig.isSSR ? "product-page-v2-build" : "product-page-v2";
  public static isDevelopment = process.env.NODE_ENV === "development";
  public static isProduction = process.env.GATSBY_ENVIRONMENT === "prod";
}
